/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Director_LabelInputs */

const en_impressum_director_label = /** @type {(inputs: Impressum_Director_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorized representatives:`)
};

const de_impressum_director_label = /** @type {(inputs: Impressum_Director_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertretungsberechtigt:`)
};

const fr_impressum_director_label = /** @type {(inputs: Impressum_Director_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Représentants autorisés :`)
};

const es_impressum_director_label = /** @type {(inputs: Impressum_Director_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Representantes autorizados:`)
};

const it_impressum_director_label = /** @type {(inputs: Impressum_Director_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rappresentanti autorizzati:`)
};

const nl_impressum_director_label = /** @type {(inputs: Impressum_Director_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertegenwoordigingsbevoegden:`)
};

const pl_impressum_director_label = /** @type {(inputs: Impressum_Director_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upoważnieni przedstawiciele:`)
};

const fi_impressum_director_label = /** @type {(inputs: Impressum_Director_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valtuutetut edustajat:`)
};

const da_impressum_director_label = /** @type {(inputs: Impressum_Director_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bemyndigede repræsentanter:`)
};

const sv_impressum_director_label = /** @type {(inputs: Impressum_Director_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behöriga företrädare:`)
};

/**
* | output |
* | --- |
* | "Authorized representatives:" |
*
* @param {Impressum_Director_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_director_label = /** @type {((inputs?: Impressum_Director_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Director_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_director_label(inputs)
	if (locale === "fr") return fr_impressum_director_label(inputs)
	if (locale === "es") return es_impressum_director_label(inputs)
	if (locale === "it") return it_impressum_director_label(inputs)
	if (locale === "nl") return nl_impressum_director_label(inputs)
	if (locale === "pl") return pl_impressum_director_label(inputs)
	if (locale === "fi") return fi_impressum_director_label(inputs)
	if (locale === "da") return da_impressum_director_label(inputs)
	if (locale === "sv") return sv_impressum_director_label(inputs)
	return en_impressum_director_label(inputs)
});